import { ClientDisplayableError, isErrorResponse } from '@standardnotes/responses';
export class LeaveVault {
    constructor(users, vaultUserServer, items, _deleteThirdPartyVault) {
        this.users = users;
        this.vaultUserServer = vaultUserServer;
        this.items = items;
        this._deleteThirdPartyVault = _deleteThirdPartyVault;
    }
    async execute(params) {
        const latestVaultListing = this.items.findItem(params.sharedVault.uuid);
        if (!latestVaultListing) {
            throw new Error(`LeaveVaultUseCase: Could not find vault ${params.sharedVault.uuid}`);
        }
        const response = await this.vaultUserServer.deleteSharedVaultUser({
            sharedVaultUuid: latestVaultListing.sharing.sharedVaultUuid,
            userUuid: this.users.sureUser.uuid,
        });
        if (isErrorResponse(response)) {
            return ClientDisplayableError.FromString(`Failed to leave vault ${JSON.stringify(response)}`);
        }
        await this._deleteThirdPartyVault.execute(latestVaultListing);
    }
}
